import { render, staticRenderFns } from "./project-list.vue?vue&type=template&id=1c036a12&scoped=true"
import script from "./project-list.vue?vue&type=script&lang=js"
export * from "./project-list.vue?vue&type=script&lang=js"
import style0 from "./project-list.vue?vue&type=style&index=0&id=1c036a12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c036a12",
  null
  
)

export default component.exports